import _ from 'lodash';
import createContext from 'create-react-context';
import PropTypes from 'prop-types';
import React from 'react';

export const DEFAULT_CONTEXT = { onHeightChange: undefined };
export const HeightChangeContext = createContext(DEFAULT_CONTEXT);

/**
 * ListItem's purpose is to position an item correctly in the list via the style props passed in.
 * It also manages height changes for its children.
 */
export default class ListItem extends React.Component {
  constructor(props) {
    super(props);
    this.handleHeightChange = this.handleHeightChange.bind(this);

    this.setRef = this.setRef.bind(this);

    this.state = {
      context: {
        height: props.height,
        onHeightChange: this.handleHeightChange,
      },
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (props.height !== state.context.height) {
      return {
        context: {
          ...state.context,
          height: props.height,
        },
      };
    }
    return null;
  }

  shouldComponentUpdate(nextProps) {
    const { children, height, id, style } = this.props;
    if (nextProps.height !== height || nextProps.id !== id || nextProps.children.key !== children.key) {
      return true;
    }
    if (!_.isEqual(nextProps.style, style)) {
      return true;
    }
    if (!_.isEqual(nextProps.children.props, children.props)) {
      return true;
    }
    if (!nextProps.isHeightValid) {
      return true;
    }
    return false;
  }

  componentDidMount() {
    this.handleHeightChange();
  }

  componentDidUpdate() {
    this.handleHeightChange();
  }

  render() {
    // HeightChangeContext allows arbitrary child items to indicate to the list that their height has changed. This way
    // we don't have pass the onHeightChange prop all the way down.
    return (
      <HeightChangeContext.Provider value={this.state.context}>
        <div className="listItem" id={`listItem-${this.props.id}`} ref={this.setRef} style={this.props.style}>
          {this.props.children}
        </div>
      </HeightChangeContext.Provider>
    );
  }

  handleHeightChange({ isManual } = { isManual: false }) {
    if (!this.node) return;

    const itemBounds = this.node.getBoundingClientRect();
    const height = itemBounds.height;

    if (Math.abs(height - this.props.height) > 0.5 || this.props.height == null || !this.props.isHeightValid) {
      this.props.onHeightChange(this.props.id, height, isManual);
    }
  }

  setRef(node) {
    this.node = node;
  }
}

ListItem.propTypes = {
  children: PropTypes.node.isRequired,
  height: PropTypes.number,
  id: PropTypes.string.isRequired,
  isHeightValid: PropTypes.bool,
  onHeightChange: PropTypes.func.isRequired,
  style: PropTypes.object,
};

export function HandleHeightChange({ children, isManual }) {
  return (
    <HeightChangeContext.Consumer>
      {({ onHeightChange }) => (
        <HandleHeightChangeBase isManual={isManual} onHeightChange={onHeightChange}>
          {children}
        </HandleHeightChangeBase>
      )}
    </HeightChangeContext.Consumer>
  );
}

HandleHeightChange.propTypes = {
  children: PropTypes.func.isRequired,
  isManual: PropTypes.bool,
  onHeightChange: PropTypes.func,
};

class HandleHeightChangeBase extends React.Component {
  constructor(props) {
    super(props);
    this.handleHeightChange = this.handleHeightChange.bind(this);
  }
  render() {
    return this.props.children({ onHeightChange: this.handleHeightChange });
  }

  handleHeightChange() {
    this.props.onHeightChange({ isManual: this.props.isManual });
  }
}

HandleHeightChangeBase.propTypes = {
  children: PropTypes.func.isRequired,
  isManual: PropTypes.bool,
  onHeightChange: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/conversation_history/virtualized/list_item.jsx